import {aiPromptBoxInitialState} from "@Components/ai-prompt-box/ai-prompt-box-library";
import type { PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";
import type {AiPromptBox, AiPromptBoxInitializationAction, AiPromptBoxReduxState, AiPromptBoxUpdateAction} from "@Components/ai-prompt-box/ai-prompt-box.types";

const aiPromptBox = createSlice({
	name: 'aiPromptBox',
	initialState: aiPromptBoxInitialState(),
	reducers: {
		initializeAiPromptBox: (state: AiPromptBoxReduxState, action: PayloadAction<AiPromptBoxInitializationAction>) => {
			const {id} = action.payload;
			state[id] = action.payload.value;
		},
		updateAiPromptBox: (state: AiPromptBoxReduxState, action: PayloadAction<AiPromptBoxUpdateAction>) => {
			const {id, value} = action.payload;
			if (state[id]) {
				state[id] = {
					...state[id],
					...value
				} as AiPromptBox
			}
		}
	}
});

export const aiPromptBoxReducer = aiPromptBox.reducer;
export const aiPromptBoxActions = aiPromptBox.actions;
